import { createSlice } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { ConfigState, config } from '../config';

const initialState: ConfigState = cloneDeep(config);

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {},
});

export default configSlice.reducer;
